<template>
  <aside
    class="c-account-nav u-margin-bottom-small"
  >
    <h1 class="t-heading-4">
      Hello {{ customerName }}
    </h1>
    <p class="c-account-nav__email t-heading-6">
      {{ customerEmail }}
    </p>
    <p class="c-account-nav__logout u-margin-bottom-x-small">
      (not {{ customerName }}?
      <a
        href="/account/logout"
        class="c-account-nav__link t-link"
      >
        Sign out
      </a>
      )
    </p>
    <p class="c-account-nav__description u-margin-bottom-x-small">
      From your account dashboard you can view your recent orders and manage your shipping and billing addresses
    </p>
    <div
      v-if="!hideNav && windowWidth < 1200"
      class="input u-margin-bottom-small"
    >
      <select
        v-model="selected"
        class="c-account-nav__select"
      >
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
    <ul
      v-else-if="!hideNav"
      class="c-account-nav__list u-list-simple"
    >
      <li
        v-for="option in options"
        :key="option.value"
        class="c-account-nav__list-item t-heading-6"
        :class="{'item-active': isActive(option.value) }"
      >
        <a
          :href="option.value"
          class="t-link"
        >
          {{ option.label }}
        </a>
      </li>
    </ul>
  </aside>
</template>

<script>

export default {
  name: 'AccountNav',
  props: {
    options: {
      type:Array,
      default: () => [],
    },
    customerName: {
      type: String,
      default: '',
    },
    customerEmail: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selected: window.location.pathname,
      windowWidth: 0,
    };
  },
  computed: {
    hideNav() {
      // hide entire nav if on order details page
      return this.selected.includes('orders');
    },
  },
  watch: {
    selected() {
      window.location.href = this.selected;
    },
  },  
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWidth);
      this.getWidth();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWidth);
  },
  methods: {
    getWidth() {
      this.windowWidth = window.innerWidth;
    },
    isActive(val) {
      // make sure 'Order History' is highlighted if user is on order details page (desktop)
      return val === this.selected || (this.selected.includes('orders') && val === '/account');
    },
  },
};
</script>

<style lang="scss" scoped>
  .c-account-nav {
    width: 100%;

    @include respond-min('desktop') {
      max-width: rem(300px);
      margin-right: rem(20px);
    }

    &__link {
      margin-left: 1ch;
    }

    &__select {
      width: 100%;
      padding: $select-padding;
    }
  }
</style>
